var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQueuePenjamin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 225,
    viewBox: "0 0 281 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_56)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8041 48.6578C68.125 59.2272 68.125 74.3042 68.125 104.458V120.542C68.125 150.696 68.125 165.773 75.8041 176.342C78.2841 179.756 81.286 182.758 84.6995 185.238C95.2689 192.917 110.346 192.917 140.5 192.917C147.247 192.917 153.238 192.917 158.594 192.831L158.594 192.267C158.593 185.415 158.593 181.242 159.163 177.642C162.297 157.856 177.814 142.338 197.6 139.205C201.2 138.634 205.373 138.635 212.225 138.635L212.789 138.635C212.875 133.28 212.875 127.288 212.875 120.542V104.458C212.875 74.3042 212.875 59.2272 205.196 48.6578C202.716 45.2443 199.714 42.2425 196.301 39.7624C185.731 32.0833 170.654 32.0833 140.5 32.0833C110.346 32.0833 95.2689 32.0833 84.6995 39.7624C81.286 42.2425 78.2841 45.2443 75.8041 48.6578ZM102.302 112.5C102.302 109.169 105.002 106.469 108.333 106.469H172.667C175.998 106.469 178.698 109.169 178.698 112.5C178.698 115.831 175.998 118.531 172.667 118.531H108.333C105.002 118.531 102.302 115.831 102.302 112.5ZM102.302 144.667C102.302 141.336 105.002 138.635 108.333 138.635H132.458C135.789 138.635 138.49 141.336 138.49 144.667C138.49 147.998 135.789 150.698 132.458 150.698H108.333C105.002 150.698 102.302 147.998 102.302 144.667ZM108.333 60.2291C108.333 58.0087 110.134 56.2083 112.354 56.2083C114.575 56.2083 116.375 58.0087 116.375 60.2291V64.25H120.396C122.616 64.25 124.417 66.0503 124.417 68.2708C124.417 70.4913 122.616 72.2916 120.396 72.2916H116.375V76.3125C116.375 78.533 114.575 80.3333 112.354 80.3333C110.134 80.3333 108.333 78.533 108.333 76.3125V72.2916H104.312C102.092 72.2916 100.292 70.4913 100.292 68.2708C100.292 66.0503 102.092 64.25 104.312 64.25H108.333V60.2291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.35 150.698C205.029 150.699 201.967 150.726 199.487 151.119C184.863 153.435 173.393 164.904 171.077 179.529C170.684 182.008 170.657 185.071 170.656 192.391C182.233 191.632 190.054 189.776 196.301 185.238C199.714 182.758 202.716 179.756 205.196 176.342C209.734 170.096 211.59 162.275 212.35 150.698Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_56",
    x: 53.125,
    y: 24.0833,
    width: 174.75,
    height: 190.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.454902 0 0 0 0 0.733333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_56",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQueuePenjamin);
export default __webpack_public_path__ + "static/media/icon_queue_penjamin.de536d61bd9ba0f70cc64dea7e9c97a3.svg";
export { ForwardRef as ReactComponent };